import { Injectable } from '@angular/core';

import { AuthApi } from '../auth-api/auth-api.service';

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {
  constructor(
    public authApi: AuthApi,
  ) {}

  /** blockAppUntilComplete
   * APP_INITIALIZER provider is configured in app.module.ts as followers to block Application render until it's tasks are complete
   {
      provide: APP_INITIALIZER, 
      multi: true, 
      useFactory: (appInitializerService: AppInitializerService) => () => appInitializerService.blockAppUntilComplete(),
      deps: [AppInitializerService],
    },
   * @returns Promise
   */
  blockAppUntilComplete(dur: number) {
    const duration = dur || 6000;
    return new Promise<void>(resolve => {
      setTimeout(() => {
        resolve();
      }, duration);
    });
  }

  init() {
    /**
     * Only opens SSE connection. Add specific message listers within services or components to trigger actions.
     * TODO: Refactor after AWS SAM migration - currently only keeps throwing errors
     */
    //  this.sseService.openSseConnection();
    this.checkUserData();
  }

  private checkUserData(): void {
    if (!localStorage.getItem('access_token')) return;
    this.authApi.setSystemID();
  }
}
